export default {
  CONFIRM_CANCEL: 'CONFIRM_CANCEL',
  CUSTOM: 'CUSTOM',
  CUSTOM_CANCEL: 'CUSTOM_CANCEL',
  INFO: 'INFO',
  RETRY_CANCEL: 'RETRY_CANCEL',
  SHOW_POPUP_ERROR: 'SHOW_POPUP_ERROR',
  SHOW_POPUP_INFO: 'SHOW_POPUP_INFO',
  SHOW_POPUP_INSTRUCTION: 'SHOW_POPUP_INSTRUCTION',
  SHOW_POPUP_WARNING: 'SHOW_POPUP_WARNING',
  WARNING: 'WARNING',
  YES_NO: 'YES_NO',
};

export const CONNECTION_ISSUE_ERROR_CODES = new Set([805, 812, 821, 827, 891, 892]);
